module.exports = __webpack_public_path__ + "img/pingjia_image_good.1775439203884.png";